import { createSelector } from 'reselect'

import type { CmsCategory } from '@/types/app-types'

import type { CategoryState } from './types'

export const categorySelector = createSelector(
    (state: CategoryState) => state.data,
    (category: CmsCategory | undefined): CmsCategory | undefined => category,
)
